import { render, staticRenderFns } from "./DocumentsPullout.vue?vue&type=template&id=135dc038&scoped=true&"
import script from "./DocumentsPullout.vue?vue&type=script&lang=js&"
export * from "./DocumentsPullout.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsPullout.vue?vue&type=style&index=0&id=135dc038&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135dc038",
  null
  
)

export default component.exports